export default "__VITE_ASSET__feBLYMpR__"